import {
  type CalendarEventData,
  type UserId,
  type WithEventType,
  type UnsavedCalendarEventData,
  type EventType,
  type CalendarEventDataWithDetails,
  type WithEventOutcomeId,
  type EventOutcomeId,
  EVENT_TYPES,
  type WithEventOutcomeHistory,
} from '../model'
import { isNotEmpty } from './isEmpty'

export function isSavedEvent(
  event: CalendarEventData | UnsavedCalendarEventData
): event is CalendarEventDataWithDetails {
  return 'eventId' in event
}

export function hasOutcomeHistory(
  event: CalendarEventData | UnsavedCalendarEventData
): event is CalendarEventDataWithDetails & WithEventOutcomeHistory {
  if (!isSavedEvent(event)) return false
  return isNotEmpty(event.outcomeHistory)
}

export function isCloseEvent(event: WithEventType): boolean {
  return event.eventType === 'Consultation'
}

export function isInterviewEvent(event: WithEventType): boolean {
  return event.eventType === 'Interview'
}

export function findCloser(event: WithEventType & Pick<CalendarEventData, 'attendeeId'>): UserId | undefined {
  if (isCloseEvent(event)) return event.attendeeId
}

export function findSetter(event: WithEventType & Pick<UnsavedCalendarEventData, 'ownerId'>): UserId | undefined {
  if (isCloseEvent(event)) return event.ownerId
}

export function eventTypeToTitle(eventType: EventType): string {
  switch (eventType) {
    case 'Consultation':
      return 'Close'
    case 'Interview':
      return '1:1'
    case 'Shadow':
      return 'Shadow day'
    default:
      return eventType
  }
}

export function isEventType(val: unknown): val is EventType {
  if (typeof val !== 'string') return false
  return EVENT_TYPES.some((e) => val === e)
}

export function toEventOutcomeId(data: WithEventOutcomeId): EventOutcomeId {
  return data.outcomeId
}
